import React from "react"
import { shape, string } from "prop-types"

export default class Link extends React.Component {
  static propTypes = {
    text: string.isRequired,
    url: string.isRequired,

    className: string,
    method: string,
    confirm: shape({
      type: string.isRequired,
      title: string.isRequired,
      text: string.isRequired,
      icon: string,
      confirmButtonText: string,
      cancelButtonText: string
    })
  }

  static defaultProps = {
    className: "",
    method: "GET"
  }

  handleClick = event => {
    const { confirm, method, url } = this.props

    event.preventDefault()

    if (method === "GET") {
      Turbolinks.visit(url)
    } else if (confirm) {
      alertModal(confirm, isConfirmed => {
        if (isConfirmed) {
          this.performAction()
        }
      })
    } else {
      this.performAction()
    }

    return false
  }

  performAction = () => {
    const { url, method } = this.props

    fetch(url, {
      method: method,
      headers: {
        "X-CSRF-Token": Rails.csrfToken()
      }
    }).then(_resp => {
      Turbolinks.visit()
    })
  }

  render() {
    const { className, url, text, icon } = this.props

    return (
      <a className={className} href={url} onClick={this.handleClick}>
        {icon && (
          <span
            className="fs-6 mr-4p"
            aria-hidden="true"
            dangerouslySetInnerHTML={{ __html: icon }}
          />
        )}
        {text}
      </a>
    )
  }
}
